import { injectable, inject } from 'inversify';
import { ObjectCompletionHandlerInterface } from './object-completion-handler-interface';
import { SectionInteraction, SectionCompletion } from '@/app/statistics/section/section-progress';
import { SectionProgressUtils, SectionProgressUtilsSymbol } from '@/app/statistics/section/section-progress-utils';
import { createInteractionId } from '../section/section-interaction-utils';

export const ADMONITION_TYPE: string = 'admonition';

@injectable()
export class AdmonitionsCompletionHandler implements ObjectCompletionHandlerInterface {

  @inject(SectionProgressUtilsSymbol)
  private sectionProgressUtils: SectionProgressUtils;

  public calculateDefaultInteractions($container: any|null): SectionInteraction[] {
    let interactions: SectionInteraction[] = [];
    $('.admonition--reveal, .term--reveal', $container).each((index: number, element: any) => {
      const $element: any = $(element);
      const id: string = createInteractionId(ADMONITION_TYPE, $element.attr('id'));
      const title: string = $element.attr('data-title') || 'admonition-reveal-component';

      interactions = [...interactions, {
        id,
        title,
        type: ADMONITION_TYPE,
        completed: false,
        items: {}
      }];
    });

    return interactions;
  }

  public setInteraction(completion: SectionCompletion, interaction: any): SectionCompletion {
    if (interaction.type && interaction.type === ADMONITION_TYPE) {
      const admonitionId: string = interaction.id;
      completion = this.sectionProgressUtils.setInteractionItemCompleted(
        completion,
        admonitionId,
        ADMONITION_TYPE
      );
    }

    return completion;
  }
}
